import { render, staticRenderFns } from "./PerExtension.vue?vue&type=template&id=306c7433&"
import script from "./PerExtension.vue?vue&type=script&lang=js&"
export * from "./PerExtension.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports